import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import { Textarea } from "@shared/ui/textarea";
import { usePatchConfigMap } from "../../../hooks"; // adjust path as needed
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

interface EditEntityModalProps {
  isOpen: boolean;
  onClose: () => void;
  entity: {
    code: string;
    name: string;
    description?: string;
    entityTypeDisplay?: string;
    remote_utility_id: number;
    map_type: string;
  };
  entityType: string;
  onUpdate?: (updatedEntity: any) => void; // Add this callback
}

const EditEntityModal: React.FC<EditEntityModalProps> = ({
  isOpen,
  onClose,
  entity,
  entityType,
  onUpdate, // Add this prop
}) => {
  const [formData, setFormData] = useState({
    description: entity.description || "",
  });

  const patchMutation = usePatchConfigMap();
  const utilityID = useRemoteUtilityId();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      mapType: "TERRITORY_JSON",
      code: entity.code,
      remote_utility_id: utilityID,
      description: formData.description,
    };

    patchMutation.mutate(payload, {
      onSuccess: (response) => {
        // Update the parent component with new data
        if (onUpdate) {
          onUpdate({
            ...entity,
            description: formData.description,
          });
        }
        onClose();
      },
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            Edit {entity?.entityTypeDisplay} {entity.name}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="description">Description</Label>
            <Textarea
              id="description"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              placeholder="Enter description"
              rows={3}
            />
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700"
              disabled={patchMutation.isPending}
            >
              {patchMutation.isPending ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditEntityModal;
